import React from "react";
import PropTypes from "prop-types";

import DateTime from "components/library/DateTime";

export default function TimePicker(props) {
  return (
    <DateTime
      dateFormat={false}
      timeFormat="h:mma zz"
      placeholder="Select a time"
      hideError={true}
      {...props}
    />
  );
}

TimePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
